import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, Box } from 'rebass/styled-components';
import DynamicTooltip from 'components/atoms/dynamicTooltip';
import { Maximize2 } from 'lucide-react';

export const ApplicantsCell = ({ job, showApplicants, hasConnect, onApplicantsClicked }) => (
  <DynamicTooltip
    sx={{
      '.tooltip-arrow:after': { ml: '-25px' },
    }}
    useTooltip={job.jobApplicantsCount && showApplicants}
    position="top-start"
    content="See applicants in Contacts screen"
    trigger={
      <Flex
        justifyContent="space-between"
        flex="1"
        alignItems="center"
        fontSize={[1]}
        onClick={() => {
          if (job.jobApplicantsCount && hasConnect) {
            onApplicantsClicked(job);
          }
        }}
        sx={{
          cursor: 'pointer',
          '&:hover #see-applicants-in-contacts-screen': { display: 'flex' },
        }}
      >
        <Text color="text">{typeof job.jobApplicantsCount === 'number' ? job.jobApplicantsCount : ' -'}</Text>

        {showApplicants && job.jobApplicantsCount > 0 && (
          <Box
            id="see-applicants-in-contacts-screen"
            sx={{
              display: 'none',
              cursor: 'pointer',
              borderRadius: '4px',
              padding: '4px',
              width: '20px',
              height: '20px',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                background: 'neutral.30',
              },
            }}
          >
            <Box as={Maximize2} size={16} sx={{ color: 'text.main' }} />
          </Box>
        )}
      </Flex>
    }
  />
);

ApplicantsCell.propTypes = {
  job: PropTypes.object.isRequired,
  showApplicants: PropTypes.bool,
  hasConnect: PropTypes.bool,
  onApplicantsClicked: PropTypes.func.isRequired,
};

ApplicantsCell.defaultProps = {
  showApplicants: false,
  hasConnect: false,
};
